/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class McpServerRequest {
    getFixupPrototypeFunction() { return McpServerRequest.fixupPrototype; }

    static newInstance(model: Partial<McpServerRequest>): McpServerRequest {
        let obj = Object.assign(new McpServerRequest(), model);
        McpServerRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<McpServerRequest>): McpServerRequest {
        if (!model) return null;
        return McpServerRequest.newInstance(<McpServerRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: McpServerRequest) {
        if (!obj) return;

        models.McpServerRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: McpServerRequest): boolean {
        Object.setPrototypeOf(obj, McpServerRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.timeout_ms === undefined) {
            this.timeout_ms = 0;
        }
        if (this.priority === undefined) {
            this.priority = 0;
        }
    }

    /**
     * Server name for MCP
     */
    name: string;

    /**
     * Human-readable display name for the MCP server.
     */
    display_name: string;

    /**
     * MCP Server description.
     */
    description: string;

    /**
     * MCP transport type (stdio, streamable-http, or rss).
     */
    transport: models.McpTransport;

    /**
     * ID of the tenant
     */
    tenant_id: string;

    /**
     * Command for stdio transport.
     */
    command: string;

    /**
     * Command arguments.
     */
    args: Array<string>;

    /**
     * Environment variables (values are sensitive).
     */
    env: { [key: string]: string; };

    /**
     * Base URL for HTTP transport.
     */
    base_url: string;

    /**
     * HTTP headers (values are sensitive).
     */
    headers: { [key: string]: string; };

    /**
     * Whether the server is active.
     */
    is_enabled: boolean;

    /**
     * Agents allowed to use this server.
     */
    business_agents: Array<models.Agents>;

    /**
     * Timeout in milliseconds.
     */
    timeout_ms: number;

    /**
     * Tool definitions.
     */
    tools: Array<any>;

    /**
     * Data freshness hint used for tool selection: real_time | daily | weekly | static.
     */
    freshness: string;

    /**
     * Tool selection priority — lower value means higher preference (e.g. 10 beats 100).
     */
    priority: number;

}
